import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';

import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { Webhooks } from '~/features/webhooks/Webhooks';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const intl = useIntl();
  const { params } = useRouting();
  const { clientId } = params;

  const nav = {
    actions: [
      {
        text: intl.formatMessage({
          id: 'IntegrationsDeprecated.navTitle',
          defaultMessage: 'Integrations',
          description: 'Navigation title for integrations page',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientIntegrations, {
          clientId: clientId as string,
        }),
      },
      {
        text: intl.formatMessage({
          id: 'Webhooks.pageTitle',
          defaultMessage: 'Webhooks',
          description: 'Webhooks page title',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientWebhooks, {
          clientId: clientId as string,
        }),
      },
    ],
  };

  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'Webhooks.pageTitle',
        defaultMessage: 'Webhooks',
        description: 'Webhooks page title',
      })}
      nav={nav}
    >
      <Webhooks />
    </PageLayout>
  );
};

export default Page;
